// extracted by mini-css-extract-plugin
export default {"bullet":"InvoiceStatusBullet_bullet__mrhYI","green":"InvoiceStatusBullet_green__9stCM","red":"InvoiceStatusBullet_red__HCRp7","yellow":"InvoiceStatusBullet_yellow__OrtP1"};